import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { OptionVerticalIcon, PenPaperIcon, TrashIcon } from '@/icons';
import { Button, Dropdown } from '@/ui_v3';
interface FolderCardMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

/**
 * 폴더 카드의 옵션 메뉴(수정·삭제).
 *
 * - `Dropdown.Portal` 을 명시한다. 카드가 `overflow` 를 가진 조상 안에 있어 빼먹으면 잘린다.
 * - Content 폭이 트리거 폭에 묶여 있어 `w-auto min-w-[8rem]` 로 되돌린다.
 */
export const FolderCardMenu = ({
  onEdit,
  onDelete
}: FolderCardMenuProps) => {
  const {
    t
  } = useTranslation(['common']);

  /*
    카드 전체가 폴더 상세로 가는 `<Link>` 라 메뉴 조작은 전파를 끊는다.
    트리거는 앵커 안에 있어 기본 동작(이동)까지 막는다.
  */
  const stopTrigger = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };
  /*
    항목은 포털에 그려져 DOM 상으로는 앵커 밖이지만, React 이벤트는 포털을 넘어 `<Link>` 의 onClick 까지
    버블링한다. Radix `onSelect` 의 커스텀 이벤트를 막아도 이 클릭은 못 막으므로 클릭 자체를 끊는다.
  */
  const stopBubble = (event: React.MouseEvent) => event.stopPropagation();
  return <Dropdown.Root data-sentry-element="unknown" data-sentry-component="FolderCardMenu" data-sentry-source-file="FolderCardMenu.tsx">
      <Dropdown.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
        <Button variant={'transparent'} intent={'neutral'} size={'xs'} aria-label={t('common:folder.edit.item.menu')} onClick={stopTrigger} data-sentry-element="Button" data-sentry-source-file="FolderCardMenu.tsx">
          <OptionVerticalIcon size={'xs'} data-sentry-element="OptionVerticalIcon" data-sentry-source-file="FolderCardMenu.tsx" />
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
        <Dropdown.Content align={'end'} className={'w-auto min-w-[8rem]'} onClick={stopBubble} data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
          {/* Radix 항목의 선택 콜백은 `onSelect` 다 — 클릭·Enter·Space 를 한 곳에서 받는다. */}
          <Dropdown.Item disabled={!onEdit} onSelect={() => onEdit?.()} data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
            <PenPaperIcon size={'xs'} fill={ICON_COLOR.default} className={'shrink-0'} data-sentry-element="PenPaperIcon" data-sentry-source-file="FolderCardMenu.tsx" />
            {t('common:global.edit.button')}
          </Dropdown.Item>
          <Dropdown.Item disabled={!onDelete} onSelect={() => onDelete?.()} data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
            <TrashIcon size={'xs'} fill={ICON_COLOR.default} className={'shrink-0'} data-sentry-element="TrashIcon" data-sentry-source-file="FolderCardMenu.tsx" />
            {t('common:global.delete')}
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>;
};